import React from 'react';

const componentName = (props) => {
    const cart = props.cart;
    console.log(cart);
    //const total = cart.reduce((total, prd)=> total+prd.price,0);
    let total = 0;
    for(let i=0; i < cart.length; i++){
        const product = cart[i]
        total = total + product.price;


    }
    let shipping = 0;
    if (total > 35){
        shipping = 0;
    }
    else if(total > 15){
        shipping = 4.99;
    }
    else if(total > 0){
        shipping = 12.99;
    }
    const tex = (total/10).toFixed(2);
    const grandTotal = (total+shipping+Number(tex)).toFixed(2);
    const formatNumber = num => {
        const precision = num.toFixed(2);
        return Number(precision);
    }

    return (
        <div>
            <h4>Order Summery</h4>
    <p>items Order: {cart.length}</p>
    <p> Product Price: {formatNumber(total)}</p>
    <p><small>Tex + VAT {tex}</small></p>
    <p><small> Shipping const: {shipping}</small></p>
    <p>Total Price: {grandTotal}</p>
    
        </div>
    );
};

export default componentName;